import { Col, Container, Row } from "react-bootstrap";
import { SimpleFormControl } from "../form/SimpleFormControl";
import { useIntl } from "react-intl";
import { SimpleFormSelect, SimpleFormSelectOption } from "../form/SimpleFormSelect";
import { Site } from "../../types/Site";
import { CkEditorCustom, SimpleLangCheck } from "src/app/components";
import SimpleFormTagsInput from "src/app/components/form/SimpleFormTagsInput";
import { useField } from "formik";

export interface IUpsertSiteFormBody {
    site?: Site;
    thematics: { options: SimpleFormSelectOption[]; loading: boolean };
    pbn: { options: SimpleFormSelectOption[]; loading: boolean };
    registrarAccount: { options: SimpleFormSelectOption[]; loading: boolean };
    usersList: {
        admins: SimpleFormSelectOption[];
        linkers: SimpleFormSelectOption[];
        managers: SimpleFormSelectOption[];
    };
}
export const UpsertSiteFormBody: React.FC<IUpsertSiteFormBody> = ({
    thematics,
    pbn,
    registrarAccount,
    usersList,
}) => {
    const { formatMessage } = useIntl();

    const [, personaMetaProps, personaHelperProps] = useField("persona");

    return (
        <Container>
            <Row>
                <Col xs={4}>
                    <SimpleFormControl
                        label={formatMessage({ id: "common.field.domain" })}
                        name="domain"
                    />

                    <SimpleFormSelect
                        label={formatMessage({ id: "common.entity.thematic" })}
                        name="thematicId"
                        values={thematics.options}
                        isLoading={thematics.loading}
                    />
                    <Row>
                        <Col xs={7}>
                            <SimpleFormSelect
                                label={formatMessage({ id: "common.entity.pbn" })}
                                name="pbnId"
                                values={pbn.options}
                                isLoading={pbn.loading}
                            />
                        </Col>
                        <Col xs={5}>
                            <SimpleFormControl
                                name="priceBought"
                                label={formatMessage({ id: "common.field.priceBought" })}
                                type="number"
                                step={0.1}
                            />
                        </Col>
                        <SimpleFormTagsInput
                            name="categories"
                            label={formatMessage({
                                id: "common.field.categories",
                            })}
                            sorted={false}
                            tagPlaceholder={formatMessage({
                                id: "common.field.placeholder.addCategories",
                            })}
                        />
                    </Row>
                </Col>
                <Col xs={4}>
                    <SimpleFormSelect
                        label={formatMessage({ id: "common.field.registrar" })}
                        name="registrarAccountId"
                        values={registrarAccount.options}
                        isLoading={registrarAccount.loading}
                        isClearable={false}
                    />
                    <SimpleFormSelect
                        label={formatMessage({ id: "common.field.admin" })}
                        name="adminId"
                        values={usersList.admins}
                        addEmpty
                    />
                    <SimpleFormSelect
                        label={formatMessage({ id: "common.field.projectManager" })}
                        name="managerIds"
                        values={usersList.managers}
                        isMulti={true}
                        addEmpty
                    />
                    <SimpleFormSelect
                        label={formatMessage({ id: "common.field.linker" })}
                        name="linkerId"
                        values={usersList.linkers}
                        addEmpty
                    />
                    <SimpleLangCheck />
                </Col>
                <Col xs={4}>
                    <Row>
                        <Row>
                            <Col xs={3}>
                                <SimpleFormControl
                                    label={formatMessage({ id: "common.field.filling" })}
                                    type="number"
                                    min={0}
                                    name="content.filling"
                                />
                            </Col>
                            <Col xs={3}>
                                <SimpleFormControl
                                    label={formatMessage({ id: "common.field.ranking" })}
                                    type="number"
                                    min={0}
                                    name="content.ranking"
                                />
                            </Col>
                            <Col xs={3}>
                                <SimpleFormControl
                                    label={formatMessage({ id: "common.field.netlinking" })}
                                    type="number"
                                    min={0}
                                    name="content.netlinking"
                                />
                            </Col>
                        </Row>
                    </Row>
                    <CkEditorCustom
                        data={personaMetaProps.value}
                        onChange={(event, editor) => {
                            personaHelperProps.setValue(editor.getData());
                        }}
                    />
                </Col>
            </Row>
        </Container>
    );
};

export default UpsertSiteFormBody;
